import React from 'react';

const LabDataValue = ({name, value, style}) => {
  const isPercent = value.indexOf('%') > -1;
  let formattedValue = value;
  if (isPercent) {
    formattedValue = value.replace('%', '');
  }
  return (
    <span style={style}>
      {`${name} ${formattedValue}`}
      {isPercent ? <sup>%</sup> : null}
    </span>
  );
};

export default LabDataValue;



// WEBPACK FOOTER //
// ./src/components/LabDataValue/lab_data_value.jsx